export const TIPO_DOCUMENTO = {
  FOTOS_DA_FACHADA: 0,
  FOTOS_DO_AMBIENTE_INTERNO: 1,
  FOTOS_DE_AREA_EXTERNA: 2,
  COPIA_DO_IPTU_ITR: 3,
  COPIA_DE_PLANTA_OU_CROQUI: 4,
};
